<template>
  <div class="page_container userListPage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/mine' }">我的</el-breadcrumb-item>
        <el-breadcrumb-item>成员管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main_container">
      <el-tabs v-model="activeName">
        <el-tab-pane label="人员管理" name="first">
          <el-table
            :data="tabListOne"
            height="57vh"
            style="width: 100%"
            @row-click="handleDetail"
          >
            <!-- <el-table-column prop="accountid" label="账户ID" width="180">
            </el-table-column> -->
            <el-table-column prop="user.truename" label="姓名" width="180">
            </el-table-column>
            <el-table-column
              prop="user.mobile"
              :formatter="formatPhone"
              label="手机号"
              width="180"
            >
            </el-table-column>
            <el-table-column prop="deptname" label="部门" width="180">
            </el-table-column>
            <el-table-column prop="rolename" label="角色"> </el-table-column>
            <!-- <el-table-column prop="joinDate" label="申请时间">
            </el-table-column> -->
            <el-table-column fixed="right" label="操作" width="100">
              <template>
                <el-button
                  type="text"
                  size="small"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane name="second">
          <template #label>
            <span v-html="labelTwo"></span>
          </template>
          <el-table
            :data="tabListTwo"
            height="57vh"
            style="width: 100%"
            @row-click="handleDetail"
          >
            <!-- <el-table-column label="账户ID" width="180">
              <template slot-scope="scope">
                {{scope.row.accountid}}<span class="badge_round"></span>
              </template>
            </el-table-column> -->
            <el-table-column prop="user.truename" label="姓名" width="180">
            </el-table-column>
            <el-table-column
              prop="user.mobile"
              :formatter="formatPhone"
              label="手机号"
              width="180"
            ></el-table-column>
            <!-- <el-table-column prop="attrname" label="用户属性" width="180">
            </el-table-column> -->
            <el-table-column prop="levelname" label="用户等级">
            </el-table-column>
            <el-table-column prop="joinDate" label="申请时间">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template >
                <el-button
                  type="text"
                  size="small"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import {encryptstringview, encryptstringadd} from '../../api/api'
import { getApplyCompanyList } from "../../api/company";
import { mapState } from "vuex";
export default {
  name: "userList",
  data() {
    return {
      activeName: "first",
      tabListOne: [],
      labelTwo: "加入申请",
      tabListTwo: [],
      qyid: ''
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID} = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { qyid } = JSON.parse(res.jsondata);
        this.qyid = qyid
        this.getApplyCompanyList();
      } else {
        this.$router.back();
      }
    },

    // 手机号隐藏四位
    formatPhone(row) {
      const phone = row.user.mobile;
      let hiddenPhone = "";

      if (phone.length === 11) {
        hiddenPhone = phone.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
      }

      return hiddenPhone;
    },

    // 动态添加标记
    renderHTML() {
      // `<span>加入申请</span>`+
      const newLabel = `<span>加入申请${
        this.tabListTwo.length > 0
          ? '<span class="badge">new</span></span>'
          : ""
      }`;
      this.labelTwo = newLabel;
    },

    handleTabs(index) {
      this.tabActive = index;
    },
    getApplyCompanyList() {
      let { qyid } = this;
      getApplyCompanyList({ qyid }).then((res) => {
        res.forEach((v) => {
          v.joinDate =
            v.checkdate.split("T")[0] + " " + v.checkdate.split("T")[1];
          v.levelname = v.user.levelname;
          v.attrname = v.user.attrname;
          if (v.checkstate == 1) {
            this.tabListOne.push(v);
          }
          if (v.checkstate == 0) {
            this.tabListTwo.push(v);
            this.renderHTML();
          }
        });
      });
    },

    handleDetail(e) {
      let { qyid } = this;
      // this.$router.push(`/companyIndex/userDetail/${e.openid}/${qyid}/${e.id}`);
      this.encryptstringadd('userDetail', {openid:e.openid, qyid, id: e.id } )
    },

     // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          })
          // window.open(this.$router.resolve({ name, params }).href, '_blank');
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.userListPage {
  .main_container {
    margin: 20px auto;
  }
  /deep/ .el-tabs__item {
    position: relative;
    .badge {
      position: absolute;
      font-size: 12px;
      color: red;
      top: -8px;
    }
  }
  /deep/ .el-table .cell {
    position: relative;
    .badge_round {
      display: inline-block;
      width: 5px !important;
      height: 5px !important;
      border-radius: 50%;
      background: red;
      position: absolute;
      top: 3px;
    }
  }
}
</style>